import { Check, Lock, Sparkles, Crown } from "lucide-react";
import { useTranslation } from "@/i18n";

const TIERS = [
  { id: "service", icon: Lock },
  { id: "assistant", icon: Sparkles },
  { id: "strategist", icon: Crown },
];

export const PlanComparison = ({ currentPlan }) => {
  const { t } = useTranslation();
  return (
    <div className="w-full space-y-3" data-testid="plan-comparison">
      <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 text-center">
        {t("assistant.compareTitle")}
      </p>
      <div className="grid gap-3 sm:grid-cols-3">
        {TIERS.map(({ id, icon: Icon }) => {
          const current = currentPlan === id;
          const features = t(`assistant.tiers.${id}.features`) || [];
          return (
            <div
              key={id}
              data-testid={`plan-card-${id}`}
              className={[
                "rounded-2xl border p-4 text-left flex flex-col",
                current ? "border-slate-900 bg-slate-50" : "border-border bg-card",
              ].join(" ")}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5">
                  <Icon className="h-4 w-4 text-slate-700" />
                  <span className="font-display text-base font-semibold text-slate-900">
                    {t(`assistant.tiers.${id}.name`)}
                  </span>
                </span>
                {current ? (
                  <span className="text-[9px] uppercase tracking-[0.14em] rounded-full bg-slate-900 text-white px-2 py-0.5">
                    {t("assistant.currentBadge")}
                  </span>
                ) : null}
              </div>
              <p className="mt-1 text-xs font-medium text-slate-600">{t(`assistant.tiers.${id}.ai`)}</p>
              <ul className="mt-2.5 space-y-1.5">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-[13px] text-slate-700">
                    <Check className="h-3.5 w-3.5 text-emerald-600 mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanComparison;
